<div *ngIf="isLoading" class="loading-overlay">
  <p-progressSpinner></p-progressSpinner>
</div>
<div class="mt-1 " >
  <div class="grid">
    <div class="col-12 p-fluid formgrid">
      <form [formGroup]="form">
          <div class="col ">
            <label>{{ 'WarehouseCalendar.CreateCalendar.Facility' | translate }}</label>
            <laas-facility-dropdown 
              formControlName="facility" 
              [isSingle]="true" 
              (onOptionDataChange)="optionsDataOnChange($event, 'facility')">
            </laas-facility-dropdown> 
          </div>
          <div class="col ">
            <label>{{ 'WarehouseCalendar.CreateCalendar.Year' | translate }}</label>
            <p-dropdown   appendTo="body" [(ngModel)]="generateParams.year" [options]="yearList" [ngModelOptions]="{standalone: true}"></p-dropdown>
          </div>
      </form>
    </div>
    <div class="ml-2 mt-4">
      <div class="col text-center">
        <button pRipple pButton label="{{ 'WarehouseCalendar.CreateCalendar.Create' | translate }}" (click)="saveBtnClick($event)"></button>
      </div>
    </div>
  </div>
</div>


